import SalaryType from './salary-type.interface';
import { SalaryTypeService } from './salary-type.service';

const service = new SalaryTypeService();

export interface SalaryTypeState {
   salaryTypes: Array<SalaryType>;
}

const state: SalaryTypeState = {
   salaryTypes: [],
};

const getters = {
   salaryTypes(state: any) {
      return state.salaryTypes;
   },
};

const mutations = {
   setSalaryTypes(state: any, newValue: any) {
      state.salaryTypes = newValue;
   },
};

const actions = {
   async getSalaryTypes(context: any) {
      return await service.getSalaryTypes().then((response) => {
         context.commit('setSalaryTypes', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
